module.exports = require('./helpers/bundle-url').getBundleURL('gK5mg') + "send-whatsapp.2a093d3e.svg";